import { reduxForm } from 'redux-form';
import PropTypes from 'prop-types';
import { ContentWrapper } from '@eti/components';
import { css, mediaQueries } from '@eti/styles';
import { ancillaryBundle, ProductBundle } from '@eti/products';
import {
  BoundNew,
  ExtraProduct,
  Option,
  PaymentMethodPrice,
  TravelerNew,
  TravelerPrice,
  TripType,
} from '@eti/types';
import { YOUR_SELECTED_TRIP } from '../../../constants/formNamesConstants';
import { sortOptions } from '../../../utils/transformBundleData';
import EtgFares from './etg-fares/EtgFares';

const wrapperStyles = css`
  margin-bottom: 24px;
  margin-top: 10px;

  @media ${mediaQueries.medium.up} {
    margin-top: 24px;
  }
`;

const ancillaryBundleStyles = css`
  background-color: #fff;
`;

const AncillaryBundleSelection = ({
  ancillaryBundleId,
  availableExtraProducts,
  bounds,
  discountAmount,
  discountPercentage,
  form,
  handleProceedButtonClick,
  onSkipStepClick,
  numberOfTravelers,
  options,
  paymentMethodPrices,
  selectedBundleId,
  setSelectedBundleOption,
  selectedExtraProducts,
  shouldDisplayEtgFares,
  travelerPrices,
  travelerPricesWithoutDiscounts,
  tripTravelers,
  tripType,
}) => {
  return shouldDisplayEtgFares ? (
    <EtgFares
      availableExtraProducts={availableExtraProducts}
      bounds={bounds}
      discountAmount={discountAmount}
      discountPercentage={discountPercentage}
      handleProceedButtonClick={handleProceedButtonClick}
      name={ancillaryBundle.name}
      numberOfTravelers={numberOfTravelers}
      onChange={setSelectedBundleOption}
      onSkipStepClick={onSkipStepClick}
      options={sortOptions(options)}
      paymentMethodPrices={paymentMethodPrices}
      selectedBundleId={selectedBundleId}
      selectedExtraProducts={selectedExtraProducts}
      travelerPrices={travelerPrices}
      travelerPricesWithoutDiscounts={travelerPricesWithoutDiscounts}
      tripTravelers={tripTravelers}
      tripType={tripType}
    />
  ) : (
    <ContentWrapper className={wrapperStyles}>
      <ProductBundle
        ancillaryBundleId={ancillaryBundleId}
        className={ancillaryBundleStyles}
        discountPercentage={discountPercentage}
        form={form}
        options={options}
        shouldShowConfirmationButton={false}
        travelers={tripTravelers}
      />
    </ContentWrapper>
  );
};

AncillaryBundleSelection.propTypes = {
  ancillaryBundleId: PropTypes.string,
  availableExtraProducts: PropTypes.arrayOf(ExtraProduct),
  bounds: PropTypes.arrayOf(BoundNew),
  discountAmount: PropTypes.number,
  discountPercentage: PropTypes.number,
  form: PropTypes.string,
  handleProceedButtonClick: PropTypes.func,
  numberOfTravelers: PropTypes.number,
  onSkipStepClick: PropTypes.func,
  options: PropTypes.arrayOf(Option),
  paymentMethodPrices: PropTypes.arrayOf(PaymentMethodPrice),
  selectedBundleId: PropTypes.string,
  selectedExtraProducts: PropTypes.arrayOf(String),
  setSelectedBundleOption: PropTypes.func,
  shouldDisplayEtgFares: PropTypes.bool,
  travelerPrices: PropTypes.arrayOf(TravelerPrice),
  travelerPricesWithoutDiscounts: PropTypes.arrayOf(TravelerPrice),
  tripTravelers: PropTypes.arrayOf(TravelerNew),
  tripType: TripType,
};

const withReduxForm = reduxForm({
  form: YOUR_SELECTED_TRIP,
  enableReinitialize: true,
});

export default withReduxForm(AncillaryBundleSelection);
